<template>
    <div
        :class="[value ? 'on-toggle-container' : 'off-toggle-container', { disabled }]"
        @click="toggleValue"
    >
        <div
            :class="[value ? 'new-on-toggle-circle' : 'new-off-toggle-circle', { disabled }]"
        ></div>
    </div>
</template>

<script>
import { Vue, Component, Prop } from 'vue-property-decorator';

@Component
export default class VrmNewToggle extends Vue {
    @Prop() value;
    @Prop({ type: Boolean, default: false }) disabled;

    toggleValue() {
        if (!this.disabled) {
            this.$emit('input', !this.value);
        }
    }
}
</script>
